import { Row } from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
  flex-wrap: nowrap;

  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  svg {
    margin-left: 8px;
    color: ${"#595959"};
  }
`;
